import { render } from "./LogoComponentRegistered.vue?vue&type=template&id=5b86d443&scoped=true"
const script = {}

import "./LogoComponentRegistered.vue?vue&type=style&index=0&id=5b86d443&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b86d443"]])

export default __exports__